import {
  getCategory,
  getEpisodeTitle,
  getLocation,
  getTitle,
  getType,
} from '@/shared/plugins/stats/helpers';
import { ProductType } from '@/shared/enums';
import { state } from '@/shared/components/player/store';

export const resetDataLayer = () => {
  window.dataLayer.push(function () {
    this.reset();
  });
};

export const getProductParams = (product) => {
  const type = getType(product);
  const isEpisode = product.type === ProductType.EPISODE;
  const isClip = product.type === ProductType.CLIP;
  const location = getLocation();

  let data = {
    param_id: product.id,
    param_title: isEpisode ? getEpisodeTitle(product) : getTitle(product),
    param_type: type,
    param_category: getCategory(product),
    param_publish_year: product.year,
    param_embed_site: location.hostname,
    param_view_name: product.mainCategory?.label,
    param_length: new Date(getDuration(product) * 1000).toISOString().substr(11, 8),
    param_tag: product.tag,
  };

  if (isEpisode) {
    data = {
      ...data,
      param_series_title: product.season.serial.originalTitle || product.season.serial.title,
      param_season: product.season.number,
      param_episode: product.episode,
    };
  }

  if (isClip) {
    data = {
      ...data,
      param_series_title: product.relatedSeriesDto?.relatedProductOriginalTitle || product.relatedSeriesDto?.relatedProductTitle,
      param_season: product.relatedSeasonDto?.number,
      param_episode: product.relatedEpisodeDto?.number,
    };
  }

  return data;
};

export const getDuration = (product) => {
  if (product.type === ProductType.PROGRAMME) {
    return calcDuration(product);
  }

  if (product.type === ProductType.LIVE && product.currentProgram) {
    return calcDuration(product.currentProgram);
  }

  return product.duration || Math.floor(state.duration);
};

const calcDuration = ({ since, till }) => {
  if (!since || !till) {
    return;
  }

  return Math.floor((till - since) / 1000); // ms to s
};

export const getAdParams = ({ type, position, breakPosition, breakTotalAds, error, totalCount }) => {
  return {
    param_ad_type: type,
    param_ad_position: position,
    param_ad_break_total_ads: breakTotalAds,
    param_ad_break_position: breakPosition,
    param_ad_break_total: totalCount,
    ...(error && { param_ad_error: error }),
  };
};
